import React from 'react';
import Dussehra2025  from 'views/Dussehra2025';

const ClassAssembly11CPage = () => {
    return <Dussehra2025 />;
  };
  
  export default ClassAssembly11CPage;

  